/**
 * Порядок карточек после переноса — то же правило, что на сервере (§12.1).
 *
 * Список задач доски плоский: карточки столбца идут в нём в порядке
 * отображения. Перенесённая задача встаёт сразу после опорной карточки
 * своего столбца; опора null — в начало столбца; без опоры (или если
 * опора не видна из-за фильтра) — по индексу position.
 *
 * Одна функция и для своего переноса (оптимистично), и для события
 * о чужом: иначе порядок у участников доски расходился бы.
 */

export interface MovePlacement {
  taskKey: string;
  toColumnId: string;
  /** Индекс в целевом столбце без самой карточки. */
  position: number;
  /** Карточка, после которой встаёт перенесённая: null — начало столбца,
   *  undefined — опоры нет, место берётся по position. */
  afterTaskKey: string | null | undefined;
}

export function applyMove(list: { key: string; columnId: string }[], move: MovePlacement): void {
  const from = list.findIndex((item) => item.key === move.taskKey);
  if (from === -1) return;
  const [task] = list.splice(from, 1);
  if (task === undefined) return;
  task.columnId = move.toColumnId;

  const inColumn = list.flatMap((item, index) => (item.columnId === move.toColumnId ? [index] : []));
  const anchor =
    typeof move.afterTaskKey === "string"
      ? list.findIndex(
          (item) => item.key === move.afterTaskKey && item.columnId === move.toColumnId,
        )
      : -1;

  let insertAt: number;
  if (anchor !== -1) {
    insertAt = anchor + 1;
  } else {
    const slot =
      move.afterTaskKey === null ? 0 : Math.min(Math.max(move.position, 0), inColumn.length);
    const lastInColumn = inColumn[inColumn.length - 1];
    insertAt = inColumn[slot] ?? (lastInColumn === undefined ? list.length : lastInColumn + 1);
  }
  list.splice(insertAt, 0, task);
}
